/** Accept only same-origin relative paths for post-sign-in redirects. */
export function safeReturnTo(value: string | null | undefined): string | null {
  const trimmed = value?.trim() ?? "";
  if (trimmed === "" || !trimmed.startsWith("/") || trimmed.startsWith("//")) {
    return null;
  }
  return trimmed;
}
